// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3KBt3","actions":"GroupTable_actions__2XqjF","deleteModalFooter":"GroupTable_deleteModalFooter___BpzT"};